import PocketBase from 'pocketbase';

// Initialize PocketBase client
const pb = new PocketBase('https://documents.vhss.org');

// Enable auto-refresh of auth token
pb.autoCancellation(false);

export default pb;
